<template>
  <div class="alarm-tab-pane">
    <general-title>{{ 'page_mdc_realtime_alarm_list' | i18n }}</general-title>
    <a-table
      size="small"
      :columns="columns"
      :dataSource="data"
      :showHeader="false"
      :customRow="customRow"
      :rowClassName="row => (row.id === currentRow.id ? 'current-row' : '')"
      :pagination="pagination"
      @change="onTableChange"
    />
    <general-title v-if="currentRow">{{ 'page_mdc_realtime_alarm_detail' | i18n }}</general-title>
    <div v-if="currentRow">
      <div>
        <label>{{ 'page_mdc_realtime_alarm_code' | i18n }}：</label>
        <span>{{ currentRow.alarmCode }}</span>
      </div>
      <div>
        <label>{{ 'page_mdc_realtime_alarm_info' | i18n }}：</label>
        <span>{{ currentRow.alarmMsg }}</span>
      </div>
      <div>
        <label>{{ 'page_mdc_realtime_alarm_time' | i18n }}：</label>
        <span>{{ currentRow.alarmTime ? dayjs(currentRow.alarmTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentRow: { id: null },
      dayjs,
    }
  },
  watch: {
    data: {
      handler(val) {
        if (val.length > 0) {
          this.currentRow = val[0]
        }
      },
      immediate: true,
    },
  },
  computed: {
    columns() {
      return [
        { title: this.$i18n.t('page_mdc_realtime_alarm_code'), dataIndex: 'alarmCode', width: 160, ellipsis: true },
        { title: this.$i18n.t('page_mdc_realtime_alarm_info'), dataIndex: 'alarmMsg', width: 160, ellipsis: true },
        {
          title: this.$i18n.t('page_mdc_realtime_alarm_time'),
          dataIndex: 'alarmTime',
          width: 160,
          ellipsis: true,
          customRender: val => dayjs(val).format('YYYY-MM-DD HH:mm:ss'),
        },
      ]
    },
    customRow() {
      return row => ({
        on: {
          click: () => {
            this.currentRow = row
          },
        },
      })
    },
  },
  methods: {
    onTableChange(e) {
      console.log(e)
      this.$emit('update:pagination', e)
    },
  },
}
</script>

<style lang="less" scoped>
.alarm-tab-pane {
  /deep/ .ant-table-tbody {
    .current-row {
      background-color: #edf8fc !important;
    }
  }
}
</style>
